/* Copyright (c) 2017 Backpack Health LLC */

import React, { FC } from 'react';

import CategorySelect from './CategorySelect';
import Colors from '../../../styles/Colors';
import { Card } from '../../../../bphComponents/bundle';
import FlexRow from '../../../components/FlexRow';

interface Props {
  cssColor: string;
  children: React.ReactFragment;
  isSelectedContent?: any;
  isExcluded: boolean;
  isSelected: boolean;
  isRequired: boolean;
  onToggle(): void;
}

export const ShareCardItemRow: FC<Props> = (props) => {
  const { onToggle, isExcluded, isSelected, isRequired, children, cssColor, isSelectedContent } = props;
  const backgroundColor = isExcluded ? Colors.grayscaleLighterYet : Colors.gsLightest;
  const contentOpacity = isSelected ? 1 : 0.9;
  const isExpanded = isSelected && isSelectedContent;

  return (
    <Card.CardSection
      hasBottomBorder
      style={{ backgroundColor }}
    >
      <FlexRow style={{ padding: '18px 16px', cursor: (isExpanded ? null : 'pointer'), alignItems: 'flex-start' }} onClick={isExpanded ? null : onToggle}>
        <div style={{ width: 'calc(100% - 40px)', opacity: contentOpacity }}>
          {children}
        </div>

        {!isExcluded &&
        <div>
          <CategorySelect
            selectedTotal={isSelected ? 1 : 0}
            allTotal={1}
            color={isRequired ? Colors.middleGray : cssColor}
            showTotals={false}
            onClick={isExpanded ? onToggle : null}
          />
        </div>
        }
      </FlexRow>
      {
        isExpanded && <div style={{ padding: '0 10px 18px 16px' }}>{isSelectedContent}</div>
      }
    </Card.CardSection>
  );
};
